import React from "react";

const NombreProducto = ({ nombre, edicion, ERROR_PRODUCT, changeInput }) => {
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-5">
                <label className="label-primary">{"Nombre del producto"}</label>
                <input
                    className="form-control default-input"
                    value={nombre}
                    maxLength={50}
                    onChange={(event) => {
                        if (/^[a-záéíóúñA-Z0-9\s]*$/.test(event.target.value)) {
                            changeInput("Nombre", event.target.value);
                        }
                    }}
                />
            </div>

            <div className="col-xs-12">
                {ERROR_PRODUCT["nombre"] == false &&
                <label className="error">{"Debe ingresar un un nombre válido."}</label>}                
                {!ERROR_PRODUCT.nombreRepetido &&  <label className="error">{"Este nombre ya existe."}</label>}
            </div>
        </div>
    )
}

export default NombreProducto;